import { useEffect } from "react"
import { Loading } from "@/shared/components/Loading/Loading"
import { delay } from "@/shared/utils/delay"
import { logout } from "@/utils/logout"
import { redirectToLogin } from "@/utils/redirectToLogin"

export function LogoutPage() {
  useEffect(() => {
    async function logoutUser() {
      await logout()
      await delay(1000) // Dirty hack to make sure the logout is fully done before redirecting
      redirectToLogin()
    }
    void logoutUser()
  }, [])

  return <Loading />
}
